const points = [
  {
    icon: "ri-database-2-line",
    label: "APPROACH",
    title: "빅데이터 기반 멀티팩터 분석",
    desc: "자체 개발한 알고리즘으로 국내외 3,000여 종목을 14개 팩터로 실시간 스크리닝하여 투자 아이디어를 도출합니다.",
  },
  {
    icon: "ri-lock-2-line",
    label: "TRANSPARENCY",
    title: "100% 투명한 수익률 공개",
    desc: "제공한 모든 투자 시그널의 히트율과 누적 수익률을 실시간 대시보드로 투명하게 공개합니다.",
  },
  {
    icon: "ri-flashlight-line",
    label: "SIGNAL",
    title: "실시간 시그널 알림",
    desc: "기관·외국인 수급 변화와 이상 거래량을 AI가 탐지하여, 회원 전용 앱으로 즉시 푸시 알림을 발송합니다.",
  },
];

export default function WhyUs() {
  return (
    <section id="why" className="relative bg-background-50 py-20 md:py-32 overflow-hidden">
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Abstract%20dark%20luxury%20architectural%20texture%20with%20soft%20champagne%20gold%20light%20streaks%20flowing%20diagonally%20across%20deep%20black%20surface%2C%20minimal%20high%20end%20financial%20visual%20identity%20background%2C%20ultra%20premium%20black%20monolithic%20texture%20with%20subtle%20warm%20gold%20highlights%2C%20cinematic%20editorial%20composition%2C%20matte%20black%20stone%20with%20fine%20golden%20lines%2C%20sophisticated%20investment%20firm%20visual%20mood%2C%20quiet%20elegant%20atmosphere&width=1920&height=1080&seq=prime-why-bg-01&orientation=landscape')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <div className="absolute inset-0 bg-background-50/85"></div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="text-xs md:text-sm tracking-widest text-primary-500 font-semibold mb-4">
              WHY PRIME PARTNERS
            </div>
            <h2 className="font-heading font-black text-3xl md:text-5xl text-foreground-50 leading-tight tracking-tight">
              왜 회원들은
              <br />
              <span className="text-gold-gradient">프라임파트너스</span>를
              <br />
              선택할까요
            </h2>
            <div className="gold-divider w-16 my-8"></div>
            <p className="text-sm md:text-base text-foreground-300 leading-relaxed">
              프라임파트너스는 단순한 종목 추천이 아닙니다.
              데이터와 분석에 기반한 투자 기준을 제시하여,
              회원이 스스로 판단할 수 있도록 돕습니다.
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            {points.map((p) => (
              <div
                key={p.label}
                className="bg-background-100/80 backdrop-blur border border-background-300/40 rounded-lg p-6 md:p-8 hover:border-primary-500/50 transition-colors"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10 border border-primary-500/40">
                    <i className={`${p.icon} text-primary-500 text-lg`}></i>
                  </div>
                  <span className="text-xs tracking-widest text-primary-500 font-semibold">
                    {p.label}
                  </span>
                </div>
                <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-50">
                  {p.title}
                </h3>
                <p className="text-sm text-foreground-300 leading-relaxed mt-3">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}